import { Component, AfterViewInit } from '@angular/core';
import {
  PAGINA_MANIFESTO_OPERADOR,
  PAGINA_PESQUISA_MANIFESTO_OPERADOR,
  USUARIO,
  PESQUISAR_USUARIO,
  PAGINA_RELATORIO_POR_USUARIO,
  PAGINA_RELATORIO_POR_OPERADOR,
  PAGINA_RELATORIO_POR_TEMA}
from 'src/app/tools/URL';
import { Router } from '@angular/router';
import { ShortcutInput } from 'ng-keyboard-shortcuts';
import { AuthService } from 'src/app/service/autenticacao/auth.service';
import { GESTOR_ROLE } from 'src/app/tools/Roles';

const MENU_USUARIO_EXTERNO = 1;
const MENU_DEMANDA = 2;
const MENU_GERENCIAL = 3;
const ACAO_INCLUIR = 'incluir';
const ACAO_PESQUISAR = 'pesquisar';
const ACAO_TOGGLE_RELATORIOS = 'toggleRelatorios';
const ACAO_TOGGLE_GRAFICOS = 'toggleGraficos';

@Component({
  selector: 'home-operador',
  templateUrl: './home-operador.component.html',
  styleUrls: ['./home-operador.component.css']
})
export class HomeOperadorComponent implements AfterViewInit {

  incluirDemanda = PAGINA_MANIFESTO_OPERADOR;
  pesquisarDemanda = PAGINA_PESQUISA_MANIFESTO_OPERADOR;
  cadastroUsuarioExterno = USUARIO;
  pesquisarUsuarioExterno = PESQUISAR_USUARIO;
  relatorioManifestosPorUsuario = PAGINA_RELATORIO_POR_USUARIO;
  relatorioManifestosPorOperador = PAGINA_RELATORIO_POR_OPERADOR;
  relatorioManifestosPorTema = PAGINA_RELATORIO_POR_TEMA;
  shortcuts: ShortcutInput[] = [];
  menuSelecionado: number;
  openedRelatoriosAccordion = false;
  openedGraficosAccordion = false;
  rolesParaRelatorios = [GESTOR_ROLE];

  constructor(private router: Router, public authService: AuthService) { }

  ngAfterViewInit(): void {

    this.shortcuts.push(
      {
        key: 'alt + u',
        preventDefault: true,
        command: () => this.menuSelecionado = MENU_USUARIO_EXTERNO
      },
      {
        key: 'alt + d',
        preventDefault: true,
        command: () => this.menuSelecionado = MENU_DEMANDA
      },
      {
        key: 'alt + g',
        preventDefault: true,
        command: () => this.menuSelecionado = MENU_GERENCIAL
      },
      {
        key: 'alt + z',
        preventDefault: true,
        command: () => this.menuSelecionado = 0
      },
      {
        key: 'alt + n',
        preventDefault: true,
        command: () => this.acaoPorMenu(ACAO_INCLUIR)
      },
      {
        key: 'alt + l',
        preventDefault: true,
        command: () => this.acaoPorMenu(ACAO_PESQUISAR)
      },
      {
        key: 'r',
        preventDefault: true,
        command: () => this.acaoPorMenu(ACAO_TOGGLE_RELATORIOS)
      },
      {
        key: 'g',
        preventDefault: true,
        command: () => this.acaoPorMenu(ACAO_TOGGLE_GRAFICOS)
      }
    );

  }

  acaoPorMenu(acao) {

    if (acao === ACAO_INCLUIR) {

      if (this.menuSelecionado === 1) {

        this.router.navigate([USUARIO]);

      } else if (this.menuSelecionado === 2) {

        this.router.navigate([PAGINA_MANIFESTO_OPERADOR]);

      }

      // TODO: incluir else para incluir registro

    } else if (acao === ACAO_PESQUISAR) {

      if (this.menuSelecionado === 1) {

        this.router.navigate([PESQUISAR_USUARIO]);

      } else if (this.menuSelecionado === 2) {

        this.router.navigate([PAGINA_PESQUISA_MANIFESTO_OPERADOR]);

      }

      // TODO: incluir else para pesquisar registro

    } else if (acao === ACAO_TOGGLE_RELATORIOS && this.menuSelecionado === 3) {

      this.openedRelatoriosAccordion = !this.openedRelatoriosAccordion;

    } else if (acao === ACAO_TOGGLE_GRAFICOS && this.menuSelecionado === 3) {

      this.openedGraficosAccordion = !this.openedGraficosAccordion;

    }

  }

  goTo(rota) {

    this.router.navigate([rota]);

  }

}
